'use client';

import { useState } from 'react';

const COMMON_MAKES = [
  'Toyota', 'Honda', 'Ford', 'Chevrolet', 'Nissan', 'Subaru', 'VW', 'Audi', 'BMW', 'Mercedes-Benz', 'Lexus', 'Acura', 'Mazda'
];

const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: currentYear - 1999 }, (_, i) => currentYear - i);

interface MilestoneSelectorProps {
  onSelect: (make: string, model: string, year: number, mileage: number) => void;
}

export default function MilestoneSelector({ onSelect }: MilestoneSelectorProps) {
  const [make, setMake] = useState('Lexus');
  const [model, setModel] = useState('NX300h');
  const [year, setYear] = useState<number>(2016);
  const [mileage, setMileage] = useState(90000);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSelect(make, model, year, Number(mileage));
  };

  return (
    <div className="bg-card rounded-2xl p-6 md:p-8 shadow-elevation-md border border-border">
      <h2 className="text-2xl font-heading font-bold text-text-primary mb-6">
        Select Your Vehicle
      </h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label htmlFor="year" className="block text-sm font-medium text-text-secondary">
              Year
            </label>
            <select
              id="year"
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
              className="w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary"
            >
              {YEARS.map(y => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>

          <div className="space-y-2">
            <label htmlFor="make" className="block text-sm font-medium text-text-secondary">
              Make
            </label>
            <select
              id="make"
              value={make}
              onChange={(e) => setMake(e.target.value)}
              className="w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary"
            >
              {COMMON_MAKES.map(m => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
          </div>
          
          <div className="space-y-2">
            <label htmlFor="model" className="block text-sm font-medium text-text-secondary">
              Model
            </label>
            <input
              id="model"
              type="text"
              value={model}
              onChange={(e) => setModel(e.target.value)}
              placeholder="e.g. MDX, RDX, Camry, NX300h"
              className="w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary"
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="mileage" className="block text-sm font-medium text-text-secondary">
              Approaching Mileage
            </label>
            <select
              id="mileage"
              value={mileage}
              onChange={(e) => setMileage(Number(e.target.value))}
              className="w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary"
            >
              <option value={15000}>15,000 Miles</option>
              <option value={30000}>30,000 Miles</option>
              <option value={40000}>40,000 Miles</option>
              <option value={45000}>45,000 Miles</option>
              <option value={50000}>50,000 Miles</option>
              <option value={60000}>60,000 Miles</option>
              <option value={75000}>75,000 Miles</option>
              <option value={90000}>90,000 Miles</option>
              <option value={100000}>100,000 Miles</option>
              <option value={120000}>120,000 Miles</option>
            </select>
          </div>
        </div>
        
        <button
          type="submit"
          className="w-full md:w-auto px-6 py-3 bg-primary text-primary-foreground font-medium rounded-lg hover:bg-primary-hover transition-smooth"
        >
          Generate Checklist
        </button>
      </form>
    </div>
  );
}
